import {
  CmpInvoiceDisplayStateEnum,
} from "../../../../graphql/types";

export const defaultManageInvoiceStatusFilter = "all" as const;

const legacyAllExceptVoidedStatusFilter = "allExceptVoided" as const;
export const manageInvoiceSentStatusFilter = "sent" as const;
// Awaiting payment and never emailed from CMP (Moeen, Oct 13 2026).
export const manageInvoiceNotSentStatusFilter = "notSent" as const;
export const manageInvoiceViewedStatusFilter = "viewed" as const;
// A settled $0 event ticket invoice (design (20) CMP Dashboard.dc.html:14332).
// The backend getCmpManageInvoices status filter owns the match.
export const manageInvoiceComplimentaryStatusFilter = "complimentary" as const;

export const getManageInvoiceOverdueAgingText = (
  daysPastDue?: number | null,
) => {
  const roundedDaysPastDue = Number.isFinite(daysPastDue)
    ? Math.max(0, Math.round(daysPastDue || 0))
    : 0;

  if (!roundedDaysPastDue) {
    return "Overdue";
  }

  return `${roundedDaysPastDue} ${
    roundedDaysPastDue === 1 ? "Day" : "Days"
  } Overdue`;
};

export type ManageInvoiceStatusFilter =
  | typeof defaultManageInvoiceStatusFilter
  | typeof legacyAllExceptVoidedStatusFilter
  | typeof manageInvoiceSentStatusFilter
  | typeof manageInvoiceNotSentStatusFilter
  | typeof manageInvoiceViewedStatusFilter
  | typeof manageInvoiceComplimentaryStatusFilter
  | CmpInvoiceDisplayStateEnum;

export const manageInvoiceStatusFilterOptions: Array<{
  value: ManageInvoiceStatusFilter;
  label: string;
}> = [
  // Design invoiceStatusOptions starts with Draft (Monday 13291850773).
  { value: CmpInvoiceDisplayStateEnum.Draft, label: "Draft" },
  {
    value: CmpInvoiceDisplayStateEnum.AwaitingPayment,
    label: "Awaiting Payment",
  },
  { value: CmpInvoiceDisplayStateEnum.Paid, label: "Paid" },
  // Design (20) CMP Dashboard.dc.html:18630 order. "Not Sent" stays after
  // "Sent" (decision B6, Oct 19 2026).
  { value: manageInvoiceComplimentaryStatusFilter, label: "Complimentary" },
  { value: CmpInvoiceDisplayStateEnum.Credited, label: "Credited" },
  { value: CmpInvoiceDisplayStateEnum.Voided, label: "Voided" },
  { value: manageInvoiceSentStatusFilter, label: "Sent" },
  { value: manageInvoiceNotSentStatusFilter, label: "Not Sent" },
  { value: manageInvoiceViewedStatusFilter, label: "Viewed" },
];
